module.exports = __webpack_public_path__ + "img/6e9dd8b.png";